module.exports = __webpack_public_path__ + "static/media/invalid.3a9c672f.png";